import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {v4 as uuid} from 'uuid';

@HookClass('SystemHook')
export class SystemHook extends BaseHook {

    @Hook('fbb54315-8d53-4597-9ff4-c599f291e312')
    public cloneSystem(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {

        const fromTo = new Map<string, string>();
        const fromToLayers = new Map<string, string>();
        const oldSystemId = inputArtifact.object.oldSystemId;
        const newSystemId = inputArtifact.object.targetSystemId;

        const layouts: any =  inputArtifact.object.layouts;
        const layers: any =  inputArtifact.object.layers;
        const folders: any =  inputArtifact.object.folders;

        const routes: any = inputArtifact.object.routes;

        const newLayouts: any[] = [];
        const newLayoutLayersXrefs: any[] = [];
        const newLayoutsSystemXrefs: any[] = [];
        const newLayers: any[] = [];
        const newLayerSystemXrefs: any[] = [];

        const newFolders: any[] = [];
        const newRoutes: any[] = [];

        const clearAudit = (item: any) => {
            delete item.createdAt;
            delete item.createdBy;
            delete item.updatedAt;
            delete item.updatedBy;
            delete item.active;
        }

        // generate new layouts
        layouts.forEach((layout: any) => {
            // clone layout
            let newId = uuid();
            fromTo.set(layout.aliasId, newId);
            layout.aliasId = newId;
            layout.id = uuid();
            clearAudit(layout);


            // clone layout system xref
            newId = uuid();
            fromTo.set(layout.layoutSystemXref.aliasId, newId);
            layout.layoutSystemXref.aliasId = newId;
            layout.layoutSystemXref.id = uuid();
            clearAudit(layout.layoutSystemXref);
            newLayoutsSystemXrefs.push(Object.assign({}, layout.layoutSystemXref));


            // clone layers
            layout.layoutLayerXrefs?.forEach((layoutLayerXref: any) => {
                // clone layout layer  xref
                newId = uuid();
                fromTo.set(layoutLayerXref.aliasId, newId);
                layoutLayerXref.aliasId = newId;
                layoutLayerXref.id = uuid();
                clearAudit(layoutLayerXref);

                newLayoutLayersXrefs.push(Object.assign({}, layoutLayerXref));
            });

            delete layout.layoutSystemXref;
            delete layout.layoutLayerXrefs;
            newLayouts.push(Object.assign({}, layout));
        });

        // generate new layers
        layers.forEach((layer: any) => {
            // clone layout
            let newId = uuid();
            fromTo.set(layer.aliasId, newId);
            fromToLayers.set(layer.aliasId, newId);
            layer.aliasId = newId;
            layer.id = uuid();
            clearAudit(layer);

            // clone layout system xref
            newId = uuid();
            fromTo.set(layer.layerSystemXref.aliasId, newId);
            layer.layerSystemXref.aliasId = newId;
            layer.layerSystemXref.id = uuid();
            clearAudit(layer.layerSystemXref);

            newLayerSystemXrefs.push(Object.assign({}, layer.layerSystemXref));

            delete layer.layerSystemXref;
            newLayers.push(Object.assign({}, layer));
        });

        // generate new folders
        folders?.forEach((folder: any) => {
            // clone layout
            let newId = uuid();
            fromTo.set(folder.aliasId, newId);
            folder.aliasId = newId;
            folder.id = uuid();
            clearAudit(folder);

            newFolders.push(Object.assign({}, folder));
        });

        // generate new routes
        routes?.forEach((route: any) => {
            // clone layout
            let newId = uuid();
            fromTo.set(route.aliasId, newId);
            route.aliasId = newId;
            route.id = uuid();
            clearAudit(route);

            newRoutes.push(Object.assign({}, route));
        });

        // adjusts layoutsSystemXrefs
        newLayoutsSystemXrefs.forEach((layoutSystemXref: any) => {
            layoutSystemXref.systemId = newSystemId;
            layoutSystemXref.layoutId = fromTo.get(layoutSystemXref.layoutId);
        });

        // adjusts layerSystemXref
        newLayerSystemXrefs.forEach((layerSystemXref: any) => {
            layerSystemXref.systemId = newSystemId;
            layerSystemXref.layerId = fromTo.get(layerSystemXref.layerId);
        });

        // adjusts layoutLayersXref
        newLayoutLayersXrefs.forEach((layoutLayerXref: any) => {
            layoutLayerXref.systemId = newSystemId;
            layoutLayerXref.layerId = fromTo.get(layoutLayerXref.layerId);
            layoutLayerXref.layoutId = fromTo.get(layoutLayerXref.layoutId);
        });

        // adjusts routes
        newRoutes.forEach((route: any) => {
            route.systemId = newSystemId;
            route.redirectId = route.redirectId ? fromTo.get(route.layoutSystemId) : null;
            route.layoutSystemId = fromTo.get(route.layoutSystemId);
            route.layerSystemId = fromTo.get(route.layerSystemId);
        });

        // adjusts folders
        newFolders.forEach((folder: any) => {
            folder.systemId = newSystemId;
            folder.parentFolderId = folder.parentFolderId ? fromTo.get(folder.parentFolderId) : null;
        });

        // adjust layouts
        newLayouts.forEach((layout: any) => {
            if (layout.html) {
                Array.from(fromToLayers.keys()).forEach((oldId: string) => {
                    layout.html = layout.html.replace(new RegExp(oldId, 'g'), fromToLayers.get(oldId));
                });
            }
        });
        // adjust layers
        newLayers.forEach((layer: any) => {
            layer.folderId = layer.folderId ? fromTo.get(layer.folderId) : null;
            if (layer.html) {
                Array.from(fromToLayers.keys()).forEach((oldId: string) => {
                    layer.html = layer.html.replace(new RegExp(oldId, 'g'), fromToLayers.get(oldId));
                });
            }
        });

        const artifact = new NickProcessArtfact();
        artifact.object = {
            layouts: newLayouts,
            layoutLayerXrefs: newLayoutLayersXrefs,
            layoutSystemXrefs: newLayoutsSystemXrefs,
            layers: newLayers,
            layerSystemXrefs: newLayerSystemXrefs,
            folders: newFolders,
            routes: newRoutes
        };
        artifact.kind = ArtfactKind.ANY;
        return of(artifact)
    }

    @Hook('186093e5-4fdd-42cd-aa7c-57d521dfd86a')
    public getEnvironment(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('SystemService')
            .pipe(concatMap((service: any) => {
                return service.getEnvironment(inputArtifact.object.systemId);
            }))
            .pipe(map((environment: any) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.object = environment;
                outputArtifact.kind = ArtfactKind.ANY;
                return outputArtifact;
            }));
    }
}
